import { FleetConfiguration } from "../models/FleetConfiguration";

export class UpdateFleetConfigurationResponse {
    fleetConfiguration?: FleetConfiguration;
}